export default function dateFormat(date: string): string {
  const dateToFormat = new Date(date.replace(/-/g, '/')); // Safari doesn't support - in dates
  const split = dateToFormat.toDateString().slice(4).split(' ');
  return `${split[0]} ${split[1]}, ${split[2]}`;
}
